/* eslint-disable import/prefer-default-export */
export const getEnvironment = () =>
  process.env.RUNTIME_ENV ||
  process.env.STORYBOOK_ENV ||
  window.RUNTIME_ENV ||
  window.HMH_ENV;
